/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatShortcut
 */
export interface ChatShortcut {
    /**
     * 
     * @type {string}
     * @memberof ChatShortcut
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatShortcut
     */
    tenant_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatShortcut
     */
    user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatShortcut
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatShortcut
     */
    value?: string;
}

/**
 * Check if a given object implements the ChatShortcut interface.
 */
export function instanceOfChatShortcut(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChatShortcutFromJSON(json: any): ChatShortcut {
    return ChatShortcutFromJSONTyped(json, false);
}

export function ChatShortcutFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatShortcut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function ChatShortcutToJSON(value?: ChatShortcut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'user_id': value.user_id,
        'name': value.name,
        'value': value.value,
    };
}

